import Qs from 'qs'
import axios from 'axios'
import store from '@/store'
import { getLocalToken } from '@/utils/auth'
import { responseOK, responseFailure } from '@/utils/rsp'

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 20000, // request timeout
  // https://www.cnblogs.com/zhuzy/p/7991770.html
  transformRequest: [function (proxyData) {
    if (proxyData.format === 'form' && typeof proxyData.data !== 'string') {
      return Qs.stringify(proxyData.data)
    } else if (proxyData.data instanceof FormData) {
      return proxyData.data
    }
    return JSON.stringify(proxyData.data)
  }]
})

// request interceptor
service.interceptors.request.use(
  config => {
    config.data = {data: config.data, format: config.format}
    // Do something before request is sent
    if (store.getters.token) {
      config.headers['Authorization'] = getLocalToken()
    }
    if (config.format === 'form') {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    } else if (config.data instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data'
    } else {
      config.headers['Content-Type'] = 'application/json'
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    responseOK(response)
    return Promise.resolve(response)
  }, error => {
    let res = responseFailure(error)
    return Promise.reject(res || error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js